export const enum ThemeModeType {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
    SKY_LIGHT = 'SKY_LIGHT',
    SKY_DARK = 'SKY_DARK',
    OCEAN_LIGHT = 'OCEAN_LIGHT',
    OCEAN_DARK = 'OCEAN_DARK',
    FLOWER_LIGHT = 'FLOWER_LIGHT',
    FLOWER_DARK = 'FLOWER_DARK',
}
